(function ($) {
  var $ = (jQuery = $);

  $.fn.selectReplace = function (prefix) {
    var chevronDown =
      '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>';

    if (prefix == "destroy") {
      $(this).off(".selectreplace");
    } else {
      return $(this)
        .filter("select:not(.replaced, .noreplace)")
        .addClass("replaced")
        .each(function () {
          //Add formatting containers
          var $opts = $(this).find("option");
          var initialText =
            $opts.filter(":selected").length > 0
              ? $opts.filter(":selected").text()
              : $opts.first().text();
          var $cont = $(this)
            .wrap('<div class="pretty-select">')
            .parent()
            .addClass("id-" + $(this).attr("id"))
            .append(
              '<span class="text"><span class="value">' +
                initialText +
                "</span></span>" +
                chevronDown
            );
          $cont.toggleClass("plaintext", $(this).hasClass("plaintext"));
        })
        .on("change.selectreplace keyup.selectreplace", function () {
          $(this)
            .siblings(".text")
            .find(".value")
            .html($(this).find(":selected").html());
        });
    }
  };

  $(document).on(
    "focusin focusout",
    ".toolbar .search-form input",
    function (e) {
      $(this)
        .closest(".search-form")
        .toggleClass("focus", e.type == "focusin");
    }
  ); /// Docked mobile nav

  var prevNavMargin = 0;
  var prevScroll = $(window).scrollTop();

  function initDockedNav() {
    var $dockedMobNav = $("#toolbar"),
      $announcementAbove = $(".header-announcement--above"),
      $pageHeader = $(".page-header"),
      mobNavHeight = $dockedMobNav.outerHeight();
    $dockedMobNav.toggleClass(
      "docked",
      $(".toolbar:first").css("min-height") == "1px"
    );

    if ($dockedMobNav.hasClass("docked")) {
      mobNavHeight = $dockedMobNav.outerHeight();
    } else {
      mobNavHeight = "";
    }

    if ($announcementAbove.length) {
      $announcementAbove.css("margin-top", mobNavHeight);
      $pageHeader.css("padding-top", "");
    } else {
      $announcementAbove.css("margin-top", "");
      $pageHeader.css("padding-top", mobNavHeight);
    }
  }

  $(window).on("debouncedresize handledockednav", initDockedNav);
  $(function () {
    initDockedNav();
  });
  $(window).on("scroll handledockednav", function () {
    var $dockedMobNav = $("#toolbar"),
      mobNavHeight = $dockedMobNav.outerHeight();
    var scroll = $(window).scrollTop();

    if (scroll < mobNavHeight) {
      $dockedMobNav.css("top", 0);
    } else {
      prevNavMargin += prevScroll - scroll;
      prevNavMargin = Math.min(Math.max(-mobNavHeight, prevNavMargin), 0);
      $dockedMobNav.css("top", prevNavMargin);
    }

    prevScroll = scroll;
  }); /// Page height assessment

  function setMinWrapperHeight() {
    // inner wrap contains the border
    $("#page-wrap-inner").css("min-height", $(window).height());
  }

  $(window)
    .on("debouncedresize setminheight", setMinWrapperHeight)
    .trigger("setminheight");
  $(function () {
    setMinWrapperHeight();
  }); /// Translations for colorbox

  /// Create mobile navigation
  var target = $('[data-section-type="header"]');
  $("body").append($("#mobile-navigation-template", target).html()); // disabling tabbing on all but first menu

  $("#mobile-nav .sub-nav a, #mobile-nav .sub-nav button").attr(
    "tabindex",
    "-1"
  ); // things for the standard nav

  if ($(".main-nav", target).length) {
    var ensureDropdownPosition = function ensureDropdownPosition() {
      setTimeout(function () {
        var pw = $(".main-nav").width() + $(".main-nav").offset().left;
        $(".main-nav .nav-item.drop-norm .sub-nav")
          .css("transform", "")
          .each(function () {
            $(this)
              .css({
                visibility: "hidden",
                zIndex: -1,
              })
              .css({
                display: "block",
              });
            var oobr = pw - ($(this).offset().left + $(this).outerWidth());
            var oobl = $(this).offset().left;

            if (oobr < 0) {
              // off the right
              $(this).css(
                "transform",
                "translate(" + Math.ceil(oobr - 1) + "px)"
              );
            } else if (oobl < 0) {
              // off the left
              $(this).css("transform", "translate(" + Math.ceil(-oobl) + "px)");
            }

            $(this).css({
              visibility: "",
              zIndex: "",
              display: "",
            });
          });
      }, 50);
    }; // Ensuring sub nav dropdown does not go off the RHS of page

    // always follow links
    $(".main-nav", target)
      .on("click", ".sub-nav-item.has-dropdown > a", function () {
        // Sub sub nav
        $(this).attr("aria-expanded", !$(this).siblings().is(":visible"));
        $(this)
          .parent()
          .toggleClass(
            "sub-nav-item--expanded",
            !$(this).siblings().is(":visible")
          );
        $(this).siblings().slideToggle(250);
        return false;
      })
      .filter("[data-col-limit]")
      .each(function () {
        // Ensure no columns go over the per-column quota
        var perCol = $(this).data("col-limit");

        if (perCol > 0) {
          $(".nav-item.dropdown.drop-norm > .sub-nav", this).each(function () {
            var $items = $(this).find(
              ".sub-nav-list:not(.sub-nav-image) > .sub-nav-item"
            );
            var cols = Math.ceil($items.length / perCol);

            for (var i = 1; i < cols; i++) {
              var $list = $('<ul class="sub-nav-list"/>')
                .append($items.slice(perCol * i))
                .insertAfter(
                  $(this).find(".sub-nav-list:not(.sub-nav-image):last")
                );
            }
          });
        }
      }); // hover events

    var navHoverDelay = 250;
    var $navLastOpenDropdown = $();
    var navOpenTimeoutId = -1;
    var $container = $(target);
    $(".main-nav", target).on(
      "mouseenter mouseleave",
      ".nav-item.dropdown",
      function (evt) {
        var $dropdownContainer = $(evt.currentTarget); // delay on hover-out

        if (evt.type == "mouseenter") {
          clearTimeout(navOpenTimeoutId);
          clearTimeout($dropdownContainer.data("navCloseTimeoutId"));
          var $openSiblings = $dropdownContainer.siblings(".open"); // close all menus but last opened

          $openSiblings.not($navLastOpenDropdown).removeClass("open");
          $navLastOpenDropdown = $dropdownContainer; // show after a delay, based on first-open or not

          var timeoutDelay = $openSiblings.length == 0 ? 0 : navHoverDelay; // open it

          var newNavOpenTimeoutId = setTimeout(function () {
            $dropdownContainer
              .addClass("open")
              .siblings(".open")
              .removeClass("open"); // look for a non-mega dropdown

            var $dropdown = false/*$dropdownContainer
              .filter(".drop-norm")
              .children(".sub-nav");*/

            if ($dropdown.length) {
              var transform = "",
                rightEdge = $("#page-wrap").width() - 30; // centre-aligned menus

              if ($dropdownContainer.closest(".align-center").length) {
                // check if left-edge is too far left
                var leftOfDropdown =
                  $dropdownContainer.offset().left +
                  $dropdownContainer.outerWidth() / 2 -
                  $dropdown.outerWidth() / 2;
                var leftEdge = 30;
                var leftOutsideAmount = leftOfDropdown - leftEdge;

                if (leftOutsideAmount < 0) {
                  transform =
                    "translateX(calc(50% + " +
                    Math.round(Math.abs(leftOutsideAmount)) +
                    "px))";
                } else {
                  // check if right-edge is too far right
                  var rightOfDropdown =
                    $dropdownContainer.offset().left +
                    $dropdownContainer.outerWidth() / 2 +
                    $dropdown.outerWidth() / 2;
                  var rightOusideAmount = rightOfDropdown - rightEdge;

                  if (rightOusideAmount > 0) {
                    transform =
                      "translateX(calc(50% - " +
                      Math.round(rightOusideAmount) +
                      "px))";
                  }
                }
              } else {
                // left-aligned menus - check if right-edge is too far right
                var rightOfDropdown =
                  $dropdownContainer.offset().left + $dropdown.outerWidth();
                var rightOusideAmount = rightOfDropdown - rightEdge;

                if (rightOusideAmount > 0) {
                  transform =
                    "translateX(-" + Math.round(rightOusideAmount) + "px)";
                }
              }

              $dropdown.css("transform", transform);
            }
          }, timeoutDelay);
          navOpenTimeoutId = newNavOpenTimeoutId;
          $dropdownContainer.data("navOpenTimeoutId", newNavOpenTimeoutId);
        } else {
          // cancel opening, close after delay, and clear transforms
          clearTimeout($dropdownContainer.data("navOpenTimeoutId"));
          $dropdownContainer.data(
            "navCloseTimeoutId",
            setTimeout(function () {
              $dropdownContainer
                .removeClass("open")
                .children(".sub-nav")
                .css("transform", "");
            }, navHoverDelay)
          );
        } // a11y

        $dropdownContainer
          .children("[aria-expanded]")
          .attr("aria-expanded", evt.type == "mouseenter");
      }
    ); // touch events

    $(".main-nav", target).on(
      "touchstart touchend click",
      ".nav-item.dropdown > .nav-item-link",
      function (evt) {
        if (evt.type == "touchstart") {
          $(this).data("touchstartedAt", evt.timeStamp);
        } else if (evt.type == "touchend") {
          // down & up in under a second - presume tap
          if (evt.timeStamp - $(this).data("touchstartedAt") < 1000) {
            $(this).data("touchOpenTriggeredAt", evt.timeStamp);

            if ($(this).parent().hasClass("open")) {
              // trigger close
              $(this).parent().trigger("mouseleave");
            } else {
              // trigger close on any open items
              $(".nav-item.open").trigger("mouseleave"); // trigger open

              $(this).parent().trigger("mouseenter");
            } // prevent fake click

            return false;
          }
        } else if (evt.type == "click") {
          // if touch open was triggered very recently, prevent click event
          if (
            $(this).data("touchOpenTriggeredAt") &&
            evt.timeStamp - $(this).data("touchOpenTriggeredAt") < 1000
          ) {
            return false;
          }
        }
      }
    ); // keyboard events

    $(".main-nav", target).on(
      "keydown",
      ".nav-item.dropdown > .nav-item-link",
      function (evt) {
        // space on parent link - toggle dropdown
        if (evt.which == 32) {
          var $parent = $(evt.target).parent();
          $parent.trigger(
            $parent.hasClass("open") ? "mouseleave" : "mouseenter"
          );
          return false;
        }
      }
    ); /// Resize nav when it doesn't fit on one line...

    if ($(".main-nav > ul > li", target).length > 1) {
      var resizeFontNavSize = function resizeFontNavSize() {
        //create invisible clone of nav list with no css tweaks
        var $clone = $(".main-nav > ul", target)
          .clone()
          .addClass("clone")
          .css({
            position: "absolute",
            visibility: "hidden",
            pointerEvents: "none",
            left: 0,
            width: "100%",
          })
          .appendTo(".main-nav");
        var $samelineCheckA = $clone.children().first();
        var $samelineCheckB = $clone.children().last();
        var $cloneLinks = $clone.find(".nav-item-link").removeAttr("style");
        var includesLogo = $clone.children(".logo-item").length > 0;
        var sanity = 500;
        var padL = Math.floor(parseInt($($cloneLinks[1]).css("padding-left")));
        var fontSize = Math.floor(
          parseInt($cloneLinks.first().css("font-size"))
        );
        var setStyles = false;
        var onSameLine;

        if (includesLogo) {
          onSameLine = function onSameLine() {
            return (
              Math.floor($samelineCheckA.offset().top) +
                $samelineCheckA.height() !=
              Math.floor($samelineCheckB.offset().top) +
                $samelineCheckB.height()
            );
          };
        } else {
          onSameLine = function onSameLine() {
            return $samelineCheckA.offset().top != $samelineCheckB.offset().top;
          };
        }

        while (onSameLine() && sanity-- > 0) {
          padL = Math.max(0, padL - 0.5);
          fontSize = Math.max(12, fontSize - 0.5);
          $cloneLinks.each(function (index) {
            $(this).css(
              index == 0
                ? {
                    fontSize: fontSize,
                  }
                : {
                    paddingLeft: padL,
                    fontSize: fontSize,
                  }
            );
          });
          setStyles = true;
        }

        if (!setStyles) {
          padL = "";
          fontSize = "";
        } //Shunt data back

        $(".main-nav .nav-item-link", target).each(function (index) {
          $(this).css(
            index == 0
              ? {
                  fontSize: fontSize,
                }
              : {
                  paddingLeft: padL,
                  fontSize: fontSize,
                }
          );
        });
        $clone.remove();
      };

      $(window)
        .on(
          "debouncedresize.resizeNavFont resizenav.resizeNavFont",
          resizeFontNavSize
        )
        .trigger("resizenav");
      $(function () {
        resizeFontNavSize();
      });
    }

    $(window)
      .on(
        "debouncedresize.headerSection ensuredropdownposition.headerSection",
        ensureDropdownPosition
      )
      .trigger("ensuredropdownposition");
    $(function () {
      ensureDropdownPosition();
    });
  }

  $(window).trigger("handledockednav"); /// Style any dropdowns

  $("select:not([name=id])", target).selectReplace();
  $(".disclosure", target)
    .add("#mobile-nav .disclosure")
    .each(function () {
      $(this).data("disclosure", new theme.Disclosure($(this)));
    }); // Announcement visibility on mobile

  var $announcementAbove = $(".header-announcement--above", target);

  if ($announcementAbove.length) {
    var adjustAnnouncementMargin = function adjustAnnouncementMargin() {
      $announcementAbove.css("margin-top", $("#toolbar", target).outerHeight());
    };

    $(window)
      .on(
        "debouncedresize.headerSection setAnnouncementHeight.headerSection",
        adjustAnnouncementMargin
      )
      .trigger("setAnnouncementHeight");
    $(function () {
      adjustAnnouncementMargin();
    });
  }

  $(function () {
    let headerWrap = $("#shopify-section-header");
    var sticky = $("body");
    headerWrap.css("min-height", headerWrap.outerHeight());
    $(window).resize(function () {
      sticky.removeClass("fixed-header");
      headerWrap.css("min-height", 0);
      setTimeout(function () {
        headerWrap.css("min-height", headerWrap.outerHeight());
        var scroll = $(window).scrollTop();
        if (scroll >= 180) sticky.addClass("fixed-header");
        else sticky.removeClass("fixed-header");
      }, 5);
    });
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll >= 180) sticky.addClass("fixed-header");
      else sticky.removeClass("fixed-header");
    });
  });
})(theme.jQuery);

function predictiveSearch(form) {
  let query = form.querySelector('input[name="q"]').value.trim();
  let results = form.querySelector(".search-results");
  if (query.length) {
    fetch(
      "/search/suggest?q=" +
        query +
        "&resources[limit]=6&resources[limit_scope]=each&section_id=predictive-search"
    )
      .then(function (response) {
        return response.text();
      })
      .then(function (res) {
        document.body.classList.add("search-opened");
        results.classList.remove("hidden");
        results.innerHTML = res;
      });
  } else {
    document.body.classList.remove("search-opened");
    results.classList.add("hidden");
  }
}
if (document.querySelector(".search-form input")) {
  document.querySelectorAll(".search-form").forEach(function (form) {
    let input = form.querySelector('input[name="q"]');
    /*
    form.addEventListener('submit', function(e){
      e.preventDefault();
      predictiveSearch(form)
    })
    */
    input.addEventListener("keydown", function (e) {
      predictiveSearch(form);
    });
    input.addEventListener("input", function (e) {
      predictiveSearch(form);
    });
    input.addEventListener("change", function (e) {
      predictiveSearch(form);
    });
    input.addEventListener("cut", function (e) {
      predictiveSearch(form);
    });
    input.addEventListener("paste", function (e) {
      predictiveSearch(form);
    });
  });
  document
    .querySelector(".search-form input")
    .addEventListener("keyup", function (e) {
      predictiveSearch(this.form);
    });
}

var navStack = [];
$(document)
  .on("click", "#mobile-nav .open-sub-nav", function () {
    // hide current & add to stack
    var $toHide = $(
      "#mobile-nav .inner:not(.hide), #mobile-nav .sub-nav.show:not(.hide)"
    ).addClass("hide");
    $toHide.find("a, button").attr("tabindex", "-1");
    navStack.push($toHide); // show new

    var $toShow = $(
      '#mobile-nav .sub-nav[data-is-subnav-for="' +
        $(this).data("sub-nav") +
        '"]'
    )
      .first()
      .addClass("show");
    $toShow.find("a, button").removeAttr("tabindex");
    $(this).attr("aria-expanded", true);
    return false;
  })
  .on("click", "#mobile-nav .close-sub-nav", function () {
    // hide current
    $(this)
      .closest(".sub-nav")
      .removeClass("show")
      .find("a, button")
      .attr("tabindex", "-1"); // reveal last seen & pop off stack

    var $popped = navStack.pop().removeClass("hide");
    $popped.find("a, button").removeAttr("tabindex");
    $popped.find('[aria-expanded="true"]').removeAttr("aria-expanded");
    return false;
  })
  .on(
    "click",
    '#mobile-nav a.nav-item-link[href="#"], #mobile-nav a.sub-nav-item-link[href="#"]',
    function () {
      // #-link opens child nav
      $(this).closest("li").find("button").click();
      return false;
    }
  ); /// Dropdowns that redirect


  /// Close side-modals
  function sideModTransOutHelper() {
    //Speed up
    $("body").addClass("sidepanel-transitioning");
    setTimeout(function () {
      $("body").removeClass("sidepanel-transitioning");
    }, 510);
  }

  function fixedNavWebkitHack() {
    if (
      $("body").hasClass("show-mobile-nav") ||
      $("body").hasClass("show-cart-summary")
    ) {
      var $headerAbove = $(".header-announcement--above");
      $(".toolbar.docked").css({
        position: "absolute",
        top:
          $(window).scrollTop() -
          ($headerAbove.length ? $headerAbove.outerHeight(true) : 0),
        left: -15,
        right: -15,
        width: "auto",
      });
    } else {
      setTimeout(function () {
        $(".toolbar").css({
          position: "",
          top: "",
          left: "",
          right: "",
          width: "",
        });
      }, 500);
    }
  }

  $(document).on("click", "#page-overlay", function () {
    sideModTransOutHelper();
    $("body").removeClass("show-cart-summary show-mobile-nav");
    fixedNavWebkitHack();
    return false;
  }); /// Toggles for side-modals

  $(document).on("click", ".toggle-mob-nav", function () {
    //prep for reveal
    $(".cart-summary").removeClass("active");
    $("#mobile-nav").addClass("active"); //toggle

    if (
      !$("body").toggleClass("show-mobile-nav").hasClass("show-mobile-nav")
    ) {
      sideModTransOutHelper();
      setTimeout(function () {
        $("#mobile-nav").removeAttr("tabindex");
        $("body a:first:visible").focus();
      }, 500);
    } else {
      // move focus to menu container
      setTimeout(function () {
        $("#mobile-nav").attr("tabindex", "0").focus();
      }, 500);
    }

    fixedNavWebkitHack();
    return false;
  });